import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Input from '../../forms/Input';
import Form from '../../forms/Form';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import Button from '../../forms/Button';
import Table from '../../table/Table';
import { formatCurrency, generateId, translate } from '../../utility/functions';
import Preput from '../../forms/Preput';
import { userRoles } from '../../RoleProtected';
import GetState from '../../GetState';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';

const KioskItems = ({ ...props }) => {

    const KioskItemForm = ({ values, ...props }) => (
        <>
            <Select
                label='Item Type'
                name='itemType'
                options={HSOptions.kioskItems.types}
                required
            />
            {values.itemType === 'Wash' && <Input
                label='Item ID'
                name='itemId'
                type='number'
                min={1}
                max={8}
                required
            />}
            <Input
                label='Name'
                name='name'
                required
            />
            <Input
                label='Price'
                name='price'
                type='price'
                max={10000}
                required
            />
            <Input
                label='SKU'
                name='sku'
            />
            <Preput
                label='Details'
                name='details'
            />
        </>
    )

    const editItem = (e, index, items) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${e.name}`,
            body: (
                <Form
                    name='KioskItemSettings'
                    inputs={{ ...e }}
                    onSubmit={e => HamQuest.put(QuestRoute.kiosks.edit(e.id), { ...e })
                        .then(() => {
                            refreshItems();
                            ModalFactory.close(id);
                        })
                    }
                >
                    {({ values }) => <KioskItemForm values={values} />}
                </Form>
            )
        })
    }

    const addItem = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add New Item`,
            body: (
                <Form
                    name='KioskItemSettings'
                    inputs={{
                        itemType: '',
                        sku: '',
                        price: '',
                        name: '',
                    }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.kiosks.items, { ...e })
                            .then(() => {
                                refreshItems();
                                ModalFactory.close(id);
                            })
                    )}
                >
                    {({ values }) => <KioskItemForm values={values} />}
                </Form>
            )
        })
    }

    const deleteItem = e => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${e.name}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Item',
                body: `Deleting ${e.name}`,
                callback: () => HamQuest.delete(QuestRoute.kiosks.edit(e.id))
            },
            confirmed: {
                title: 'Success',
                body: `${e.name} successfully deleted.`,
            },
            finally: () => refreshItems()
        })
    }

    const [items, refreshItems] = GetState(QuestRoute.kiosks.items)

    const tableConfig = {
        data: items,
        controls: [<Button roles={userRoles.editProducts} onClick={addItem}>Add New Item</Button>],
        headers: [
            {
                label: 'Type',
                propKey: 'itemType',
                options: true
            }, {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Item ID',
                propKey: 'itemId',
            }, {
                label: 'SKU',
                propKey: 'sku',
            }, {
                label: 'Price',
                propKey: 'price',
                type: 'number'
            }
        ],
        renderFormat: (e, index, data) => (
            <ManagementRow
                key={generateId()}
                controls={[
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editItem(e, index, data)}>Edit</Button>,
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteItem(e)}>Delete</Button>
                ]}
            >
                <td>{translate(e.itemType)}</td>
                <td>{e.name}</td>
                <td>{e.itemId || '-'}</td>
                <td>{e.sku}</td>
                <td>{formatCurrency(e.price)}</td>
            </ManagementRow>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default KioskItems;